const fi = {
  sourceInfo: {
    paragraph1:
      "SOURCE ry on TAMKin tieto- ja viestintätekniikan ainekerho. Kerho on perustettu vuonna 2016. Yhdistykseksi rekisteröidyimme vuotta myöhemmin. Näkyvin osa kerhoamme on oma kerhohuoneemme, joka löytyy A-siiven kerhohuonekäytävän päästä, huoneesta A0-35.",
    paragraph2:
      "SOURCEn tarkoituksena tiivistää TiTe-verkostoa ja jakaa tietoa alamme mahdollisuuksista. SOURCE järjestää jäsenilleen mm. sauna- ja lautapeli-iltoja. Merkittävimpiä tapahtumiamme ovat perinteiset TiTeLANit.",
    paragraph3:
      "SOURCE toimii tiiviissä yhteistyössä Tamkon, TIRO ry:n sekä muiden TAMKin kerhojen kanssa, osallistumalla tapahtumien järjestämiseen.",
    paragraph4:
      "Kerhon jäseniksi ovat tervetulleita kaikki koulutusohjelmasta riippumatta. Yritysvierailut ovat kuitenkin suunnattu tietotekniikan opiskelijoille.",
  },
  partnersTitle: "Yhteistyökumppanimme",
  nav: {
    frontPage: "Etusivu",
    membership: "Jäsenyys",
    events: "Tapahtumat",
    titelan: "TiTeLAN",
    iotSeminaari: "IoT-seminaari",
    suggestions: "Ehdotukset",
    contact: "Yhteystiedot",
    association: "Yhdistys",
    board: "Hallitus",
    partners: "Kumppanit",
    products: "Tuotteet",
    rules: "Säännöt",
  },
  footerInfo: {
    address1: "Kerhotila: A-siipi kellarikerros A0-35",
    address2:
      "Löytääksesi kerhohuoneen, kävele kaikkien muiden ainejärjestöjen kerhohuoneiden ohi, kävele suoraan vastaan tulevan oven läpi jajatka melkein ulko-ovelle asti.",
  },
  happeningNow: "Käynnissä!",
  time: {
    days: "päivää",
    hours: "tuntia",
    minutes: "minuuttia",
    seconds: "sekuntia",
  },
  roles: {
    chairperson: "Puheenjohtaja",
    viceChairperson: "Varapuheenjohtaja",
    treasurer: "Rahastonhoitaja",
    secretary: "Sihteeri",
    secretaryLegacy: "Sihteeri ja viestintävastaava",
    socialMediaAndCommunications: "Some- ja viestintävastaava",
    eventsCoordinator: "Tapahtumavastaava",
    leisureCoordinator: "Vapaa-aikavastaava",
    membershipAndClubroomCoordinator: "Jäsen- ja kerhisvastaava",
    externalRelationsCoordinator: "Ulkosuhdevastaava",
    internationalStudentsCoordinator: "Kansainvälisyysvastaava",
    kopo: "Koulutuspoliittinenvastaava",
    webmaster: "Webmaster",
    officer: "Toimihenkilö",
  },
  boardMembers: "Hallitus",
  officers: "Toimihenkilöt",
  newBoardDescription:
    "Uusi hallitus ja toimihenkilöt valitaan joka vuosi syyskokouksessa ja ehdolle asettuminen tapahtuu saapumalla paikalle kokoukseen ja ilmaisemalla halukkuutensa siinä kohtaa kokousta, kun hallitusta/toimihenkilöitä valitaan.",
  pastBoards: "Menneet hallitukset ja toimihenkilöt",
  contactInformation: "Yhteystiedot",
  email: "Sähköposti",
  address: "Osoite",
  harassmentContact: "Häirintäyhdyshenkilö",
  harassmentInfo: {
    paragraph1:
      "Kaikilla on oikeus turvalliseen elämään ilman minkäänlaista häirintää. Asiaton, syrjivä ja loukkaava puhe, käytös tai viestittely ei kuulu Tampereen ammattikorkeakouluun eikä muuhunkaan opiskelijaelämään.",
    paragraph2:
      "Sourcen häirintäyhdyshenkilö tukee ja neuvoo häirintää kohdanneita opiskelijoita. Myös häirintää nähneet voivat ottaa yhteyttä häirintäyhdyshenkilöhön mieltä askarruttavissa kysymyksissä, kuten toimintatavoista keskustellakseen. Häirintäyhdyshenkilö ei lähde toteuttamaan jatkotoimenpiteitä ilman suostumusta. Hän ei myöskään pidä kirjaa yhteyttä ottaneista ja hänellä on täysi vaitiolovelvollisuus.",
    paragraph3: "Häirintäyhdyshenkilön tavoitat",
  },
  eventsDescription:
    "Source ry järjestää monenlaisia tapahtumia jäsenilleen, kuten yritysvierailuja eli ekskursioita, erilaisia vapaa-ajan tapahtumia, sekä seminaareja ICT-alasta.",
  leisureActivities: "Vapaa-aika",
  leisureActivitiesExamples: "Vapaa-ajan tapahtumia ovat esimerkiksi",
  companyEvents: "Yritystapahtumat",
  companyEventsDesctiption:
    "Erilaisia tapahtumia, joissa opiskelijat pääsevät tutustumaan yrityksiin, niiden kehittämiin tuotteisiin/ratkaisuihin, kuulemaan mielenkiintoisia puheenaiheita ICT:stä ja viettämään iltaa yrityksien henkilökunnan kanssa. Tälläisiä tapahtumia ovat:",
  events: {
    studentParties: "Erilaiset opiskelijabileet",
    newbiesNight: "Uusien ilta",
    // sportShifts: "Kerhon liikuntavuoro",
    titelan: "TiteLanit",
    boardGameNights: "Lautapeli-illat",
    other: "Muuta ajanviettoa",
    excursions: "Ekskursiot",
    seminars: "Seminaarit",
    expos: "Messut",
  },
  // iotSeminarInfo: {
  //   paragraph1:
  //     "IoT-Seminaari on Tampereen ammattikorkeakoululla järjestettävä seminaaritapahtuma, joka kerää yhteen alan yrityksiä, asiantuntijoita ja opiskelijoita.",
  //   paragraph2:
  //     "IoT-Seminaarissa perehdytään tieteen ja tekniikan alan monipuolisiin ratkaisuihin ja innovaatioihin seminaariesitelmien puitteissa sekä päivän aikana voi tutustua eri yritysten ständeihin ja verkostoitua.",
  // },
  membershipInfo: {
    paragraph1:
      "SOURCEn vuotuinen jäsenmaksu on 5€. Jäsenyyden voi hankkia joko hallituksen jäseneltä tai SOURCEn verkkokaupasta. Ostaessasi neljän vuoden jäsenyyden kerralla saat SOURCEn haalarimerkin ilmaiseksi (kysy merkkiä hallituksen jäseneltä).",
    paragraph2: "Jäsenenä voit",
    paragraph3:
      "SOURCEn kerhohuone löytyy Kuntokadun A-siiven pohjakerroksen tilasta A0-35 (kerhohuonekäytävää melkein ulos asti ja vasemmalle). Kerhohuoneelta saat lähes aina tukea opiskeluusi ja sieltä löytyy myös pelejä.",
    paragraph4:
      "Lisäksi SOURCE osallistuu koulutuspolitiikkaan yhdessä TAMKOn ja tietotekniikan linjan kanssa.",
  },
  membershipBenefits: {
    events:
      "osallistua jäsenille tarkoittuihin tapahtumiin, kuten saunailtoihin",
    excursions: "osallistua yritysvierailuille",
    coffeTea: "hakea kerhohuoneelta kahvia tai teetä ilmaiseksi",
    votingRight: "asettua ehdolle hallitukseen ja osallistua syys- ja kevätkokouksiin",
  },
  becomeMember: "Liity jäseneksi",
  pageNotFound: "Tais mennä väärin",
  pageNotFoundExplanation: "Typoista päätellen olet jo valmistunut insinööri!",
  backToMain: "Haluun pois",
  corporatePartnershipTitle: "Yritysyhteistyö",
  companyPartnership: {
    intro:
      "SOURCE ry:n yritysyhteistyön tavoitteena on lähentää opiskelijoita yritysten kanssa. Yritysyhteistyö luo hyvän pohjan opiskelijoille tutustua yrityksiin, oppia uutta alasta ja verkostoitua. Yrityksille yhteistyö SOURCE ry:n kanssa takaa näkyvyyden TAMK:in tietotekniikan opiskelijoiden keskuudessa ja luo mahdollisuuden tutustua tuleviin alansa ammattilaisiin.",
    diverseFlexible:
      "Yritysyhteistyö on monimuotoista ja joustavaa. Tarkoituksenamme on lyötää aina tapauskohtaisesti paras mahdollinen vaihtoehto molemmille osapuolille. Alla on kerrottu hieman tarkemmin mahdollisuuksista.",
    jobPostings: {
      title: "Perusta",
      description:
        "SOURCE ry tarjoaa yrityksillä mahdollisuuden lähettää työpaikkailmoituksia ja muita tiedotteitaan jäsenilleen sopimuksen mukaisesti. Pakettiin kuuluu yrityksen logo SOURCE ry:n etusivulle, sekä lyhyt kuvaus yrityksestä yhteistyökumppanit sivustolle.",
    },
    excursions: {
      title: "Excursiot eli yritysvierailut",
      description:
        "Excursiot ovat SOURCE ry:n jäsenten keskuudessa suosittuja tapahtumia. Excursiot ovat paras mahdollisuus opiskelijoille päästä tutustumaan kiinnostavaan yritykseen ja sen toimintaan. Yrityksille excursiot taas ovat mainio mahdollisuus päästä tutustumaan tietotekniikan opiskelijoihin ja tulevaisuuden tekijöihin.",
    },
    guestLectures: {
      title: "Vierailijaluennot",
      description:
        "Vierailijaluennot ovat hieno mahdollisuus jakaa ammattilaisten osaamista opiskelijoille. Opiskelijat ovat aina kiinnostuneita työelämässä käytetyistä toimintatavoista ja teknologioista. Vierailijaluentoja varten SOURCE ry voi varata tilat TAMK:ilta.",
    },
    // iotSeminar: {
    //   title: "IoT-seminaari",
    //   description:
    //     "IoT-Seminaari on Tampereen ammattikorkeakoululla vuosittain järjestettävä seminaaritapahtuma, joka kerää yhteen alan yrityksiä, asiantuntijoita ja opiskelijoita. Tapahtuman järjestää SOURCE ry ja tapahtuman tuotot ohjataan lyhentämättöminä IoT-Seminaarin kehittämiseen ja SOURCE ry:n toimintaan. Yritykset voivat osallistua IoT-seminaariin lunastamalla itselleen ständipaikan ja/tai järjestämällä puheenvuoron. Ständipaikkojen hinnat ovat paikasta riippuen tyypillisesti olleet 150-250€ / 2vrk ja puheenvuorot yrityksille ilmaisia.",
    // },
    overallsAds: {
      title: "Haalarimainokset",
      description:
        "Haalarimainokset ovat mainio mahdollisuus yritykselle hankkia näkyvyyttä opiskelijoiden keskuudessa. SOURCE ry tarjoaa yrityksille mahdollisuuden ostaa mainospaikan opiskelijahaalareistaan. Mainospaikkojen hinnat vaihtelevat sijainnin ja koon mukaan 500€ ja 1000€ välillä. Haalarimainosten tuotot ohjataan vuosittain haalareiden hankintaan ja jäsenistölle järjestettävään toimintaan.",
    },
  },
  webpage: "Verkkosivut",
  rules: "Säännöt",
  clubRoomSuggestions: {
    paragraph1: "Kerro meille mitä kerhohuoneelta puuttuu!",
    paragraph2:
      "Täytä alla olevan linkin takana oleva lomake ja kirjaa, mitä haluaisit hallituksen hankkivan kerhohuoneelle.",
  },
  clubRoomAquisitions: "Kerhohuoneen hankinnat",
  companySuggestions: {
    paragraph1:
      "Onko sinulla mielessäsi jokin yritys johon haluaisit päästä töihin tai muuten vaan tutustumaan ja näkemään, minkälaista siellä on?",
    paragraph2: "Laita meille oma ekskursio ehdotuksesi!",
    paragraph3: "Minkä yrityksen sinä haluaisit nähdä?",
  },
  excursionSuggestions: "Ekskursio ehdotukset",
  nextTitelan: "Seuraavat TiTeLANit",
  tickets: "Liput",
  titelanInfo: {
    title: "TiTeLANIt on keväällä ja syksyllä järjestettävä LAN -tapahtuma",
    description:
      "Titelanit saivat alkunsa 2008 syksyllä, kun omaa verkkopelitapahtumaa ei ollut vielä TAMKilta löytynyt. Pitkän historiansa aikana Titelanit ovat olleet osallistujamääriltään suosittuja ja erilaisia peliturnauksia on järjestetty laidasta laitaan lanien aikana. Titelanien järjestyspaikaksi on vakiintunut TAMKin liikuntasali, mutta muutamaan otteeseen myös Tampereen keskustan Demolaa on käytetty. Tapahtuma on järjestetty katkeamatta joka vuosi, lukuun ottamatta pandemia ajan taukoa.",
  },
  pastTitelans: "Menneet Titelanit",
  location: "Sijainti",
  tournaments: "Turnaukset",
  associationInfo: {
    paragraph1:
      "SOURCE ry on TAMKin tieto- ja viestintätekniikan ainekerho. Kerho on perustettu vuonna 2016. Yhdistykseksi rekisteröidyimme vuotta myöhemmin. Näkyvin osa kerhoamme on oma kerhohuoneemme, joka löytyy A-siiven kerhohuonekäytävän päästä, huoneesta A0-35.",
    paragraph2:
      "SOURCEn tarkoituksena tiivistää TiTe-verkostoa ja jakaa tietoa alamme mahdollisuuksista. SOURCE järjestää jäsenilleen mm. sauna- ja lautapeli-iltoja. Merkittävimpiä tapahtumiamme ovat perinteiset TiTeLANit sekä yrityksiä TAMKiin keräävä IoT-seminaari.",
    paragraph3:
      "SOURCE toimii tiiviissä yhteistyössä Tamkon, TIRO ry:n sekä muiden TAMKin kerhojen kanssa, osallistumalla tapahtumien järjestämiseen.",
    paragraph4:
      "Kerhon jäseniksi ovat tervetulleita kaikki koulutusohjelmasta riippumatta. Yritysvierailut ovat kuitenkin suunnattu tietotekniikan opiskelijoille.",
  },
};

export default fi;
